import { useState, useEffect } from 'react';
import styles from './AdBanner.module.css';

interface AdBannerProps {
  className?: string;
}

// Reklam verisi için interface tanımı
interface AdItem {
  image: string;
  url: string;
  alt?: string;
}

const AdBanner: React.FC<AdBannerProps> = ({ className }) => {
  const [currentAdIndex, setCurrentAdIndex] = useState(0);
  
  // Reklam görselleri ve bağlantıları
  const ads: AdItem[] = [
    {
      image: '/vagonla-reklam-728x90-tr-35.png',
      url: '/',
      alt: 'vagonla'
    },
    {
      image: '/vagonla-reklam-728x90-bus.png',
      url: '/lines',
      alt: 'Otobüs hatları'
    }
  ];

  useEffect(() => {
    // 10 saniyede bir reklam değişimi
    const interval = setInterval(() => {
      setCurrentAdIndex((prevIndex) => (prevIndex + 1) % ads.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Reklama tıklama işleyicisi
  const handleAdClick = () => {
    const currentAd = ads[currentAdIndex];
    
    // Harici link kontrolü (http ile başlayan)
    if (currentAd.url.startsWith('http')) {
      window.open(currentAd.url, '_blank');
    } else {
      // Uygulama içi yönlendirme için location kullanımı
      window.location.href = currentAd.url;
    }
  };

  return (
    <div className={`${styles.adBanner} ${className || ''}`}>
      <div className={styles.adContainer}>
        <img 
          src={ads[currentAdIndex].image} 
          alt={ads[currentAdIndex].alt || "Reklam"} 
          className={styles.adImage}
          onClick={handleAdClick}
          title={`${ads[currentAdIndex].alt || "Reklam"} - Tıkla ve keşfet!`}
        />
        <span className={styles.adLabel}>Reklam</span>
        {ads.length > 1 && (
          <div className={styles.adIndicators}>
            {ads.map((_, index) => (
              <span 
                key={index} 
                className={`${styles.adIndicator} ${index === currentAdIndex ? styles.activeIndicator : ''}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdBanner;
